@if (type === 'select') {
  <rt-bulk-select
    [allSelected]="selected"
    [selectedCount]="currentViewSelectedCount"
    [disabled]="disabled"
    [active]="active"
    [indeterminateState]="isIndeterminateState()"
    (select)="handleSelect($event)"
    [variant]="variant"
  />
}

@if (type === 'checkbox') {
  <rt-checkbox
    [indeterminateState]="isIndeterminateState()"
    [checked]="selected"
    [disabled]="disabled"
    (valueChange)="handleSelect($any($event))"
    (click)="$event.stopPropagation()"
  >
    <ng-content />
  </rt-checkbox>
}
